import { uploadForm } from "@ec2/contracts/uploads";

/**
 * POST a blob to a presigned S3 POST with upload progress (XHR — fetch has no
 * upload progress). S3 checks the signed policy — size and type — and answers
 * 204; anything outside the policy is a 403 with nothing stored. Resolves on
 * 2xx, rejects otherwise.
 */
export function postWithProgress(
  url: string,
  fields: Record<string, string>,
  body: Blob,
  onProgress?: (fraction: number) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable && onProgress) onProgress(event.loaded / event.total);
    });
    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress?.(1);
        resolve();
      } else {
        reject(new Error(`upload failed: HTTP ${xhr.status}`));
      }
    });
    xhr.addEventListener("error", () => reject(new Error("upload failed: network error")));
    xhr.addEventListener("abort", () => reject(new Error("upload aborted")));
    xhr.send(uploadForm(fields, body));
  });
}
